<template>
    {{ prefijo ? prefijo + ': ' : '' }} {{ importeTotalMostrado ?? 0 }} € <i v-if="tieneReajuste" class="text-primary fas fa-info-circle" :id="tooltipId"></i>

    <DxTooltip v-if="tieneReajuste" v-bind="dxTooltipProps">
        <div class="text-start">
            <div class="mb-1">
                <span class="fw-bold">Original:</span> {{ importeCalculadoMostrado }} €
            </div>
            <div class="mb-1">
                <span class="fw-bold">Reajuste:</span> {{ importeReajusteMostrado }} €
            </div>
            <div>
                <span class="fw-bold">Motivo:</span> {{ motivoReajuste }}
            </div>
        </div>
    </DxTooltip>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { DxTooltip } from "devextreme-vue";
import _ from "lodash";
import { esPrefijoRetrocomision, importeRetribucionParaMostrar } from "@helpers/retribucion-economica-helper";

export type DesgloseRetribucionEconomicaProps = {
    prefijo?: "Comisión" | "Retrocomisión";
    importeTotal?: number | null;
    importeCalculado?: number | null;
    importeReajuste?: number | null;
    motivoReajuste?: string | null;
    esRetrocomision?: boolean;
};

const props = defineProps<DesgloseRetribucionEconomicaProps>();

const tooltipId = _.uniqueId("tooltip-motivo-reajuste-economica-");

const dxTooltipProps: DxTooltip = {
    hideOnOutsideClick: false,
    target: `#${tooltipId}`,
    showEvent: "mouseenter",
    hideEvent: "mouseleave",
};

const esRetrocomision = computed(
  () => props.esRetrocomision ?? esPrefijoRetrocomision(props.prefijo),
);

const importeTotalMostrado = computed(() =>
  importeRetribucionParaMostrar(props.importeTotal, esRetrocomision.value),
);
const importeCalculadoMostrado = computed(() =>
  importeRetribucionParaMostrar(props.importeCalculado, esRetrocomision.value),
);
const importeReajusteMostrado = computed(() =>
  importeRetribucionParaMostrar(props.importeReajuste, esRetrocomision.value),
);

const tieneReajuste = computed(() => props.importeReajuste != null && props.importeReajuste !== 0);

</script>

<style lang="scss" scoped></style>
